var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditPencil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    fill: "#3282FF",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.631.828c-.303.05-.069-.172-5.064 4.82L.896 10.316l-.423 1.823c-.232 1.003-.429 1.87-.437 1.927a.884.884 0 0 0 .014.25c.086.421.429.715.875.751.146.012.351-.03 2.025-.415l1.863-.427 4.68-4.68c4.202-4.203 4.686-4.695 4.743-4.822a.917.917 0 0 0-.073-.885c-.047-.069-.714-.751-1.481-1.516C11.389 1.032 11.278.927 11.15.881a1.027 1.027 0 0 0-.519-.053m1.167 1.903c.557.567 1.142 1.163 1.299 1.325l.287.293-.172.182c-.095.1-.431.444-.746.765l-.573.584-1.336-1.334-1.336-1.333.771-.756c.424-.416.775-.756.782-.756.006-.001.466.463 1.024 1.03M9.956 5.194a80.604 80.604 0 0 1 1.319 1.334c0 .015-5.365 5.372-6.451 6.441l-.464.457-1.711.359c-.941.198-1.714.357-1.718.354-.004-.003.169-.765.384-1.691l.391-1.685L5.159 7.32a776.606 776.606 0 0 1 3.466-3.444c.007 0 .606.592 1.331 1.318",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditPencil);
export default __webpack_public_path__ + "static/media/edit-pencil.8729b0c2c9d062e6695da2219e91dfbb.svg";
export { ForwardRef as ReactComponent };